import { render, staticRenderFns } from "./CourseOptions.vue?vue&type=template&id=3fcfbd9f&"
import script from "./CourseOptions.vue?vue&type=script&lang=js&"
export * from "./CourseOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports